import React from 'react';

import { ThemeProvider } from '@mui/material';
import './App.css'; // This defines the styles. See MyReactComponent.js for more info
import './BrandDesign.css'; //contains classes with Siemens colors for buttons and other interactive elements
import darkTheme from './theme';
import WordSearch from 'didactic-word-search';
import "didactic-word-search/dist/index.css"

const App = () => {

  const wordList = ["Compliance", "Umwelt", "Zukunft", "Reputation", "Energie"];

    return (
            <ThemeProvider theme={darkTheme}>
              <WordSearch wordList={wordList} />
            </ThemeProvider>
    )
}

export default App;